import React, { useEffect } from 'react';
import { modalStore } from 'components/layout/modals/ModalStore';
import { TOKEN_KEY } from 'shared/security/AuthStore';

function readStoredToken(rawValue) {
	try {
		return JSON.parse(rawValue);
	} catch {
		return rawValue;
	}
}

// Shown in the Job tab while the visitor signs in from the tab it opened.
// The session lands in localStorage, which other tabs observe via `storage`.
export default function ReferralSignInPending({ onReopen, onSignedIn }) {
	useEffect(() => {
		const handleStorage = event => {
			if (event.key !== TOKEN_KEY || !event.newValue) return;
			const token = readStoredToken(event.newValue);
			if (token) {
				onSignedIn(token);
			}
		};

		window.addEventListener('storage', handleStorage);
		return () => window.removeEventListener('storage', handleStorage);
	}, [onSignedIn]);

	const close = () => {
		modalStore.closeDialog();
	};

	return (
		<div className="ExternalApplicationModal ReferralSignInPending">
			<div className="external-application-modal-top">
				<button
					type="button"
					className="external-application-modal-close"
					onClick={close}
					aria-label="Close">
					<img src="/ats/icons/close-3-icon.svg" alt="" />
				</button>
			</div>
			<div className="external-application-modal-title">
				<h2>Finish signing in</h2>
				<p>
					Complete your sign-in in the other tab.
					<br />
					Once you’re signed in, you’ll automatically continue your referral.
				</p>
			</div>
			<div className="external-application-modal-footer">
				<button
					type="button"
					className="external-application-btn is-secondary"
					onClick={close}>
					Cancel
				</button>
				<button
					type="button"
					className="external-application-btn is-primary"
					onClick={onReopen}>
					Reopen Sign In
				</button>
			</div>
		</div>
	);
}
